module.exports = __webpack_public_path__ + "img/eart.png?daf5bba19c718c747f5b3e231ed7a3b9";